import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`bg-gradient-to-r from-gray-900 to-gray-800 text-white shadow-lg fixed w-full z-10 transition-all duration-300 ${isScrolled ? 'backdrop-blur-md' : ''}`}>
      <div className="container mx-auto flex justify-between items-center p-4">
        <div className="flex items-center text-2xl font-bold">
          <img src="images/uniconn/logoUniconn-white.png" alt="Uniconn Logo" className="w-8 h-8 mr-2" />
          <img src="images/uniconn/logoUniconn-1.png" alt="Uniconn Logo" className="w-13 h-8 mr-2" />
        </div>
        <nav className="hidden md:flex space-x-4">
          <Link 
            to="home" 
            smooth={true} 
            duration={1000} 
            className="hover:text-gray-400 transition duration-300 cursor-pointer"
          >
            Início
          </Link>
          <Link 
            to="about" 
            smooth={true} 
            duration={1000} 
            className="hover:text-gray-400 transition duration-300 cursor-pointer"
          >
            Sobre Nós
          </Link>
          <Link 
            to="services" 
            smooth={true} 
            duration={1000} 
            className="hover:text-gray-400 transition duration-300 cursor-pointer"
          >
            Serviços
          </Link>
          <Link 
            to="projects" 
            smooth={true} 
            duration={1000} 
            className="hover:text-gray-400 transition duration-300 cursor-pointer"
          >
            Projetos
          </Link>
          <Link 
            to="contact" 
            smooth={true} 
            duration={1000} 
            className="hover:text-gray-400 transition duration-300 cursor-pointer"
          >
            Contato
          </Link>
        </nav>
        <div className="md:hidden flex items-center">
          <button onClick={toggleMenu}>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16m-7 6h7'}></path>
            </svg>
          </button>
        </div>
      </div>
      {isOpen && (
        <nav className="md:hidden flex flex-col space-y-2 p-4 bg-gray-800">
          <Link 
            to="home" 
            smooth={true} 
            duration={1000} 
            className="hover:text-gray-400 transition duration-300 cursor-pointer"
            onClick={toggleMenu}
          >
            Início
          </Link>
          <Link 
            to="about" 
            smooth={true} 
            duration={1000} 
            className="hover:text-gray-400 transition duration-300 cursor-pointer"
            onClick={toggleMenu}
          >
            Sobre Nós
          </Link>
          <Link 
            to="services" 
            smooth={true} 
            duration={1000} 
            className="hover:text-gray-400 transition duration-300 cursor-pointer"
            onClick={toggleMenu}
          >
            Serviços
          </Link>
          <Link 
            to="projects" 
            smooth={true} 
            duration={1000} 
            className="hover:text-gray-400 transition duration-300 cursor-pointer"
            onClick={toggleMenu}
          >
            Projetos
          </Link>
          <Link 
            to="contact" 
            smooth={true} 
            duration={1000} 
            className="hover:text-gray-400 transition duration-300 cursor-pointer"
            onClick={toggleMenu}
          >
            Contato
          </Link>
        </nav>
      )}
    </header>
  );
}

export default Header;
